function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#card_generic_svg__clip0)"
}, React.createElement("path", {
  d: "M20.872 0H2.128A2.117 2.117 0 0 0 0 2.106v11.788C0 15.057.953 16 2.128 16h18.744A2.117 2.117 0 0 0 23 13.894V2.106A2.117 2.117 0 0 0 20.872 0z",
  fill: "#0066B2"
}), React.createElement("path", {
  d: "M20.03 8.881h-3.959a.475.475 0 0 0-.477.472v2.65c0 .261.214.473.478.473h3.959a.475.475 0 0 0 .477-.473v-2.65a.475.475 0 0 0-.477-.472z",
  fill: "#BCBCBC"
}), React.createElement("path", {
  d: "M13.173 9.656H2.28V11.7h10.894V9.656z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M23 2.89H0v3.242h23V2.89z",
  fill: "#36424E"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "card_generic_svg__clip0"
}, React.createElement("path", {
  fill: "#fff",
  d: "M0 0h23v16H0z"
})));

var SvgCardGeneric = function SvgCardGeneric(props) {
  return React.createElement("svg", _extends({
    width: 23,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxwYXRoIGQ9Ik0yMC44NzIzIDBIMi4xMjc2OEMwLjk1MjU5NCAwIDAgMC45NDI5MjQgMCAyLjEwNjA4VjEzLjg5MzlDMCAxNS4wNTcxIDAuOTUyNTk0IDE2IDIuMTI3NjggMTZIMjAuODcyM0MyMi4wNDc0IDE2IDIzIDE1LjA1NzEgMjMgMTMuODkzOVYyLjEwNjA4QzIzIDAuOTQyOTI0IDIyLjA0NzQgMCAyMC44NzIzIDBaIiBmaWxsPSIjMDA2NkIyIi8+CjxwYXRoIGQ9Ik0yMC4wMzA2IDguODgxMDVIMTYuMDcxNUMxNS44MDggOC44ODEwNSAxNS41OTQ0IDkuMDkyNDggMTUuNTk0NCA5LjM1MzNWMTIuMDAzNUMxNS41OTQ0IDEyLjI2NDMgMTUuODA4IDEyLjQ3NTggMTYuMDcxNSAxMi40NzU4SDIwLjAzMDZDMjAuMjk0MSAxMi40NzU4IDIwLjUwNzcgMTIuMjY0MyAyMC41MDc3IDEyLjAwMzVWOS4zNTMzQzIwLjUwNzcgOS4wOTI0OCAyMC4yOTQxIDguODgxMDUgMjAuMDMwNiA4Ljg4MTA1WiIgZmlsbD0iI0JDQkNCQyIvPgo8cGF0aCBkPSJNMTMuMTczNCA5LjY1NjM5SDIuMjc4NjNWMTEuNzAwNEgxMy4xNzM0VjkuNjU2MzlaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjMgMi44ODk4N0gwVjYuMTMyMTZIMjNWMi44ODk4N1oiIGZpbGw9IiMzNjQyNEUiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMCI+CjxyZWN0IHdpZHRoPSIyMyIgaGVpZ2h0PSIxNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgCardGeneric as ReactComponent };